var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      attrs: {
        title: "编辑菜单管理",
        visible: _vm.drawerVisible,
        direction: "rtl",
        size: "720px",
        "destroy-on-close": "",
        "wrapper-closable": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.drawerVisible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _c("div", { staticClass: "drawer-container" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "menu-bar-manage",
          },
          [
            _c("el-alert", {
              staticClass: "menu-bar-tip",
              attrs: {
                title: _vm.MENU_BAR_IMAGE_TIP,
                type: "warning",
                "show-icon": "",
                closable: false,
              },
            }),
            _vm._v(" "),
            _c(
              "draggable",
              {
                attrs: { handle: ".drag-handle", animation: "200" },
                on: { end: _vm.onDragEnd },
                model: {
                  value: _vm.menuList,
                  callback: function ($$v) {
                    _vm.menuList = $$v
                  },
                  expression: "menuList",
                },
              },
              _vm._l(_vm.menuList, function (item, index) {
                return _c("div", { key: index, staticClass: "menu-item-row" }, [
                  _c("div", { staticClass: "menu-item-main" }, [
                    _c("div", { staticClass: "icon-upload-group" }, [
                      _c("div", { staticClass: "icon-upload-block" }, [
                        _c("span", { staticClass: "icon-label" }, [
                          _vm._v("选中"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "upLoadPicBox",
                            on: {
                              click: function ($event) {
                                return _vm.uploadIcon(index, "selectedIcon")
                              },
                            },
                          },
                          [
                            item.selectedIcon
                              ? _c("div", { staticClass: "pictrue" }, [
                                  _c("img", {
                                    attrs: { src: item.selectedIcon },
                                  }),
                                ])
                              : _c("div", { staticClass: "upLoad" }, [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-camera cameraIconfont",
                                  }),
                                ]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "icon-upload-block" }, [
                        _c("span", { staticClass: "icon-label" }, [
                          _vm._v("未选中"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "upLoadPicBox",
                            on: {
                              click: function ($event) {
                                return _vm.uploadIcon(index, "unselectedIcon")
                              },
                            },
                          },
                          [
                            item.unselectedIcon
                              ? _c("div", { staticClass: "pictrue" }, [
                                  _c("img", {
                                    attrs: { src: item.unselectedIcon },
                                  }),
                                ])
                              : _c("div", { staticClass: "upLoad" }, [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-camera cameraIconfont",
                                  }),
                                ]),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "menu-item-fields" },
                      [
                        _c(
                          "div",
                          { staticClass: "field-row" },
                          [
                            _c("span", { staticClass: "field-label" }, [
                              _vm._v("标题："),
                            ]),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "field-control",
                              attrs: {
                                placeholder: "请输入",
                                size: "small",
                                maxlength: "20",
                              },
                              model: {
                                value: item.title,
                                callback: function ($$v) {
                                  _vm.$set(item, "title", $$v)
                                },
                                expression: "item.title",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "field-row field-row--with-action" },
                          [
                            _c("span", { staticClass: "field-label" }, [
                              _vm._v("链接："),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                staticClass: "field-control",
                                attrs: { placeholder: "请选择", size: "small" },
                                on: {
                                  change: function ($event) {
                                    return _vm.onLinkTypeChange(item)
                                  },
                                },
                                model: {
                                  value: item.linkType,
                                  callback: function ($$v) {
                                    _vm.$set(item, "linkType", $$v)
                                  },
                                  expression: "item.linkType",
                                },
                              },
                              _vm._l(_vm.MENU_LINK_OPTIONS, function (opt) {
                                return _c("el-option", {
                                  key: opt.value,
                                  attrs: { label: opt.label, value: opt.value },
                                })
                              }),
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "field-action field-action--group",
                              },
                              [
                                _c("el-switch", {
                                  staticClass: "status-switch",
                                  attrs: {
                                    "active-value": 1,
                                    "inactive-value": 0,
                                  },
                                  on: {
                                    change: function (val) {
                                      return _vm.handleStatusChange(val, index)
                                    },
                                  },
                                  model: {
                                    value: item.status,
                                    callback: function ($$v) {
                                      _vm.$set(item, "status", $$v)
                                    },
                                    expression: "item.status",
                                  },
                                }),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass: "el-icon-rank drag-handle",
                                  attrs: { title: "拖动排序" },
                                }),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass: "el-icon-remove remove-btn",
                                  class: {
                                    "is-disabled": !_vm.canRemoveModule(index),
                                  },
                                  attrs: { title: "删除" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeModule(index)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        item.linkType === "share"
                          ? [
                              _c(
                                "div",
                                { staticClass: "field-row" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "field-label field-label--required",
                                    },
                                    [_vm._v("装修页id：")]
                                  ),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    staticClass: "field-control",
                                    attrs: {
                                      placeholder: "请输入",
                                      size: "small",
                                    },
                                    model: {
                                      value: item.linkId,
                                      callback: function ($$v) {
                                        _vm.$set(item, "linkId", $$v)
                                      },
                                      expression: "item.linkId",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "field-row" },
                                [
                                  _c("span", { staticClass: "field-label" }, [
                                    _vm._v("权益包key："),
                                  ]),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    staticClass: "field-control",
                                    attrs: {
                                      placeholder: "请输入",
                                      size: "small",
                                    },
                                    model: {
                                      value: item.benefitPackageKey,
                                      callback: function ($$v) {
                                        _vm.$set(item, "benefitPackageKey", $$v)
                                      },
                                      expression: "item.benefitPackageKey",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              false
                                ? _c(
                                    "div",
                                    { staticClass: "field-row" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "field-label" },
                                        [_vm._v("核销跳转id：")]
                                      ),
                                      _vm._v(" "),
                                      _c("el-input", {
                                        staticClass: "field-control",
                                        attrs: {
                                          placeholder: "请输入",
                                          size: "small",
                                        },
                                        model: {
                                          value: item.offlineJumpId,
                                          callback: function ($$v) {
                                            _vm.$set(item, "offlineJumpId", $$v)
                                          },
                                          expression: "item.offlineJumpId",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]),
                ])
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "add-module-btn",
                attrs: {
                  type: "primary",
                  disabled: _vm.menuList.length >= _vm.MENU_BAR_MAX_COUNT,
                },
                on: { click: _vm.addModule },
              },
              [_vm._v("\n      添加模块\n    ")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "drawer-footer" },
          [
            _c("el-button", { on: { click: _vm.handleClose } }, [
              _vm._v("取消"),
            ]),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { type: "primary", loading: _vm.saving },
                on: { click: _vm.handleSave },
              },
              [_vm._v("保存")]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }